module.exports = __webpack_public_path__ + "img/arrow-alt-circle-up.22dbe068.svg";